import useTranslator from "../../hooks/useTranslator";
import styles from "./NoteForLandlord.module.css";

const NoteForLandlord = ({ note, onEditNote }) => {
  const { _t } = useTranslator();

  return (
    <section
      className="tenant-profile-placeholder-card tenant-profile-placeholder-card--landlord-note"
      aria-labelledby="note-for-landlord-title"
    >
      <h2 id="note-for-landlord-title">
        {_t("noteForLandlord", "Note for landlord")}
      </h2>
      <p className={styles.subtitle}>
        {_t(
          "noteForLandlordPlaceholder",
          "Doesn't affect your completeness, but landlords read it."
        )}
      </p>
      <div className={styles.noteWrap}>
        {onEditNote && (
          <button
            type="button"
            className={styles.editBtn}
            onClick={onEditNote}
            aria-label={_t("edit", "Edit")}
          >
            {_t("edit", "Edit")}
          </button>
        )}
        <p className={`${styles.note} ${!note ? styles.empty : ""}`}>
          {note || _t("noInformation", "No information")}
        </p>
      </div>
    </section>
  );
};

export default NoteForLandlord;
